import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject } from '../utils'
import { Loading } from '../misc'
import AdditionalInformation from './additional_information'
import { Boolean } from '../ui'

export default class WardrobeStylist extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [
                'wardrobe_own_inventory',
                'wardrobe_own_steamer',
                'wardrobe_own_clothing_racks',
            ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Professional Equipment
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Boolean
                            error={ errors.wardrobe_own_inventory }
                            label="Do you own a wardrobe inventory?"
                            name="wardrobe_own_inventory"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'wardrobe_own_inventory') }
                        />
                        <Boolean
                            error={ errors.wardrobe_own_steamer }
                            label="Do you own a steamer?"
                            name="wardrobe_own_steamer"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'wardrobe_own_steamer') }
                        />
                        <Boolean
                            error={ errors.wardrobe_own_clothing_racks }
                            label="Do you own clothing racks?"
                            name="wardrobe_own_clothing_racks"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'wardrobe_own_clothing_racks') }
                        />

                        <AdditionalInformation
                            { ...this.props }
                            label={
                                'Additional details about your kit items and experience. Please ' +
                                'list anything else you want us to know about.'
                            }
                            wrapped={ false }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/wardrobe_stylist.js